import React from "react";
import { Typography, List, ListItem, ListItemText, Box } from "@mui/material";
import ContentPageLayout, { bodyTextSx, sectionTitleSx } from "../Pages/ContentPageLayout";
import { NAV } from "../Navbar/navbarTheme";
import { modernSlaveryIntro, modernSlaverySections } from "./modernSlaverySections";

const listItemSx = {
  padding: 0,
  display: "list-item",
  pl: 2.5,
  mb: 0.5,
};

const bulletListSx = {
  color: NAV.ink,
  mb: 2,
  pl: { xs: 2, sm: 2.5 },
  listStyleType: "disc",
};

const linkSx = {
  color: NAV.navy,
  fontWeight: 600,
  textDecoration: "underline",
};

function SlaveryBulletList({ items }) {
  if (!items?.length) return null;
  return (
    <List dense sx={bulletListSx}>
      {items.map((item) => (
        <ListItem key={item} sx={listItemSx}>
          <ListItemText
            primary={item}
            primaryTypographyProps={{
              sx: { fontSize: "1rem", lineHeight: 1.65 },
            }}
          />
        </ListItem>
      ))}
    </List>
  );
}

function SlaverySectionBlock({ index, section }) {
  const {
    title,
    paragraphs = [],
    bullets,
    closing = [],
    whistleblowingEmail,
    approval,
  } = section;

  return (
    <Box component="section" sx={{ mb: 1 }}>
      <Typography component="h2" sx={sectionTitleSx}>
        {index}. {title}
      </Typography>

      {paragraphs.map((text) => (
        <Typography key={text} sx={bodyTextSx}>
          {text}
        </Typography>
      ))}

      <SlaveryBulletList items={bullets} />

      {closing.map((text) => (
        <Typography key={text} sx={bodyTextSx}>
          {text}
        </Typography>
      ))}

      {whistleblowingEmail ? (
        <Typography sx={bodyTextSx}>
          Concerns can be reported confidentially by email to:{" "}
          <Box component="a" href="mailto:admin@uktomars.co.uk" sx={linkSx}>
            admin@uktomars.co.uk
          </Box>
        </Typography>
      ) : null}

      {approval ? (
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ ...bodyTextSx, fontWeight: 600, mb: 0.5 }}>
            Signed for and on behalf of UK TO MARS LTD
          </Typography>
          <Typography sx={{ ...bodyTextSx, mb: 0.5 }}>
            Hazhar Khalid Ali - Director UK TO MARS LTD
          </Typography>
          <Typography sx={{ ...bodyTextSx, mb: 0 }}>Date: 15 June 2026</Typography>
        </Box>
      ) : null}
    </Box>
  );
}

const ModernSlaveryStatement = () => (
  <ContentPageLayout
    title="UK TO MARS LTD"
    subtitle={
      <>
        Modern Slavery & Human Trafficking Statement
        <br />
        Last Updated: 15 June 2026
      </>
    }
  >
    {modernSlaveryIntro.map((text) => (
      <Typography key={text} sx={bodyTextSx}>
        {text}
      </Typography>
    ))}

    {modernSlaverySections.map((section, index) => (
      <SlaverySectionBlock
        key={section.title}
        index={index + 1}
        section={section}
      />
    ))}
  </ContentPageLayout>
);

export default ModernSlaveryStatement;
